import { withFormik } from "formik"
import moment from "moment"
import * as Yup from "yup"
import { CURRENT_PAYMENT_TYPE } from "./constants"
import PagoForm from "./form"

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    importe: Yup.number()
      .required(t("errors.importRequired"))
      .typeError(t("errors.numericValue")),
    fecha: Yup.date()
      .max(moment(new Date()), t("errors.previousDateCurrent"))
      .required(t("errors.dateRequired")),
    descripcion: Yup.string().nullable(),
    cuentaBancariaId: Yup.string().nullable(),
    empresaId: Yup.string().required(t("errors.selectedOnePlease")),
  })

const NewPagoForm = withFormik({
  validateOnChange: true,
  validateOnBlur: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data }) => {
    return {
      importe: data?.importe || "",
      fecha: data?.fecha,
      descripcion: data?.descripcion || null,
      cuentaBancariaId: data?.cuentaBancariaId || "",
      razonSocial: data?.razonSocial || null,
      empresaId: data?.empresaId || "",
      facturaId: data?.facturaId || null,
      tipo: data?.tipo || CURRENT_PAYMENT_TYPE.PAGO,
    }
  },
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),

  handleSubmit: async (values, { props }) => {
    const modifiedValues = {
      cuentaBancariaId: values.cuentaBancariaId || null,
      descripcion: values.descripcion,
      fecha: values.fecha,
      importe: values.importe,
      empresaId: values.empresaId,
      facturaId: values.facturaId,
    }

    // @ts-expect-error TS(2339): Property 'isEditView' does not exist on type 'obje...
    if (props.isEditView) {
      // @ts-expect-error TS(2339): Property 'handleEdit' does not exist on type 'obje...
      props.handleEdit(modifiedValues)
    } else {
      // @ts-expect-error TS(2339): Property 'handleCreate' does not exist on type 'ob...
      props.handleCreate(values.tipo || values.valueKey, modifiedValues)
    }
  },
})(PagoForm)

export default NewPagoForm
